import { LOGO_URL } from "../lib/api";

export default function Logo({ className = "h-12 w-auto", priority = false }) {
  return (
    <img
      src={LOGO_URL}
      alt="MP Autobedrijf"
      data-testid="mp-logo"
      width="600"
      height="600"
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      className={`${className} object-contain select-none drop-shadow-[0_0_22px_rgba(230,0,0,0.35)]`}
      style={{ imageRendering: "auto" }}
    />
  );
}
